module.exports = __webpack_public_path__ + "toGroom-jp-r-w.66fb97d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-jp-r-w.jpg
// module id = JTfW
// module chunks = 0